export const isCognitoUserAssociatedWithLoggiUser = user => {
  try {
    return !Number.isNaN(JSON.parse(user['custom:access']).loggi_user_id);
  } catch {
    return false;
  }
};

export default isCognitoUserAssociatedWithLoggiUser;
